import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const StripeWalletWidgetPage = () =>
  import('@modules/stripe/stripe-wallet/components/stripe-wallet-widget-page.vue');

export default [{
  name: '',
  path: '',
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      name: 'wallet',
      path: '/wallet',
      component: StripeWalletWidgetPage,
      meta: {
        auth: true,
        permission: Permissions.values.subpropertyRead,
      },
    },
  ],
}];
